export class DocumentEditToolControl {
  isNewTextObjectCreatable: boolean;
  isNewImageObjectCreatable: boolean;
  isNewLineObjectCreatable: boolean;
  isNewShapeObjectCreatable: boolean;
  isObjectStyleEditable: boolean;
}
